import React, { FC } from 'react'
import styled from 'styled-components'

import { circle } from '@Globals/Style/mixins'

interface AbundanceProps {
  count?: number
}

const StyledAbundance = styled.div`
  position: relative;
`

const StyledCounter = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${circle('18px')};
  background-color: ${({ theme }) => theme.colors.primary};
  color: #fff;
  font-size: 0.75rem;
`

export const Abundance: FC<AbundanceProps> = ({ children, count }) => {
  if (!count) {
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {children}
      </>
    )
  }

  return (
    <StyledAbundance>
      {children}
      <StyledCounter>{count}</StyledCounter>
    </StyledAbundance>
  )
}
